import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { mapFamilyApiError } from '~entities/family/lib/map-family-api-error';
import type { FamilyCommunicationLevel } from '~entities/family/model/family.type';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const updateFamilyContact = async (args: {
  familyId: string;
  parentId: string;
  communicationLevel?: FamilyCommunicationLevel;
  portalAccessEnabled?: boolean;
}) => {
  const { familyId, parentId, ...body } = args;
  const response = await baseAPI.patch(
    `/v2/families/${familyId}/contacts/${parentId}`,
    body,
  );
  return response.data;
};

export const useUpdateFamilyContact = (studentId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateFamilyContact,
    onSuccess: () => {
      toast.success('Guardian settings updated');
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_BY_STUDENT],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.FAMILY_HUB],
      });
    },
    onError: (error: unknown) => {
      toast.error(mapFamilyApiError(error, 'Failed to update guardian'));
    },
  });
};
